// 這是Webpack掛載起始點
import Layout from './layout.vue'
import Index from '../.components/index.vue'
import Show from '../.components/show.vue'
import New from '../.components/new.vue'
import Edit from '../.components/edit.vue'

const main_router = 'scan_action_prototypes'
const new_router = 'new_scan_action_prototype'
const edit_router = 'edit_scan_action_prototype'
const show_router = 'scan_action_prototype'

const router = [
    {
        path: '',
        component: Index,
        name: 'scan_action_prototypes',
        meta: {
            api_name: 'api_v1_provider_scan_action_prototypes',
            breadcrumb: [main_router],
            btns: [new_router]
        }
    },
    {
        path: 'new',
        component: New,
        name: 'new_scan_action_prototype',
        meta: {
            api_name: 'api_v1_provider_scan_action_prototype_create',
            breadcrumb: [main_router, new_router]
        }
    },
    {
        path: ':identity/edit',
        component: Edit,
        name: 'edit_scan_action_prototype',
        meta: {
            api_name: 'api_v1_provider_scan_action_prototype_update',
            breadcrumb: [main_router, edit_router]
        }
    },
    {
        path: 'show/:identity',
        component: Show,
        name: 'scan_action_prototype',
        meta: {
            api_name: 'api_v1_provider_scan_action_prototype',
            breadcrumb: [main_router, show_router]
        }
    }
]

export default router
